import {
  ADD_USER,
  DELETE_USER,
  SET_CURRENT,
  CLEAR_CURRENT,
  UPDATE_USER,
  FILTER_USERS,
  CLEAR_FILTER,
  USER_ERROR,
  GET_USERS,
  CLEAR_USERS
} from '../types';

export default (state, action) => {
  switch (action.type) {
    case GET_USERS:
      // console.log('userReducer', action.payload);
      return {
        ...state,
        users: action.payload.data,
        loading: false
      };
    case ADD_USER:
      return {
        ...state,
        users: [action.payload.data, ...state.users],
        loading: false
      };
    case UPDATE_USER:
      console.log('updateUser', action.payload);
      return {
        ...state,
        users: state.users.map(user =>
          user.id === action.payload.data.id ? action.payload.data : user
        ),
        loading: false
      };
    case DELETE_USER:
      //console.log(action);
      return {
        ...state,
        users: state.users.filter(user => user.id !== action.payload),
        loading: false
      };
    case CLEAR_USERS:
      return {
        ...state,
        users: null,
        filtered: null,
        error: null,
        current: null,
        loading: false
      };
    case SET_CURRENT:
      //console.log(`Set Current in Reducer ${JSON.stringify(action.payload)}`);
      return {
        ...state,
        current: action.payload
      };
    case CLEAR_CURRENT:
      return {
        ...state,
        current: null
      };
    case FILTER_USERS:
      return {
        ...state,
        filtered: state.users.filter(user => {
          const regex = new RegExp(`${action.payload}`, 'gi');
          return user.name.match(regex) || user.email.match(regex);
        }),
        loading: false
      };
    case CLEAR_FILTER:
      return {
        ...state,
        filtered: null,
        loading: false
      };
    case USER_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    default:
      return state;
  }
};
